module.exports = __webpack_public_path__ + "assets/img/btn-view-d86e97d6.png";